// extracted by mini-css-extract-plugin
export default {"currency":"currency__1vXod","signPrefix":"signPrefix__2LFhl"};